// auto-generated by Typewriter template _models.tst from PortCall.Models\PortCall\BatchRecurrencePeriod.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BatchRecurrenceFrequency } from 'server/enums/BatchRecurrenceFrequency';

// BatchRecurrencePeriodData is the class that BatchRecurrencePeriod serializes to/from
export interface BatchRecurrencePeriodData {
	
	
    CustomDays : number;
    Frequency : BatchRecurrenceFrequency;
}

// BatchRecurrencePeriodOptions is the class which may be passed to the BatchRecurrencePeriod constructor to define optional initial data values
export interface BatchRecurrencePeriodOptions {
	
	
    CustomDays? : number;
    Frequency? : BatchRecurrenceFrequency;
}

export class BatchRecurrencePeriod {
	
	
    public CustomDays : DataSignal<number>;
    public Frequency : DataSignal<BatchRecurrenceFrequency>;

    constructor();
    constructor(data : BatchRecurrencePeriodOptions);
    constructor(data: BatchRecurrencePeriodOptions | null = null) {
	    
	    
        this.CustomDays = jsonableObservable(S.value<number>(data && data.CustomDays !== undefined ? data.CustomDays : 0));
        this.Frequency = jsonableObservable(S.value<BatchRecurrenceFrequency>(data && data.Frequency !== undefined ? data.Frequency : 0));
    }

    static key(obj : BatchRecurrencePeriod) {
        return ;
    }
    
    static dataKey(obj : BatchRecurrencePeriodOptions) {
        return ;
    }

    static update(obj : BatchRecurrencePeriod, data : BatchRecurrencePeriodOptions) {
        S.freeze(() => {
	        
	        
            if (data.CustomDays !== undefined) obj.CustomDays(data.CustomDays);
            if (data.Frequency !== undefined) obj.Frequency(data.Frequency);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BatchRecurrencePeriod.ts